<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form" v-bind="this.$attrs">
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="uniformOrdersStatus"
              :items="uniformOrderStatuses"
              clear-icon="mdi-close"
              item-text="title"
              item-value="value"
              label="Trạng thái đơn"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="uniformOrdersStatusReturned"
              :items="uniformOrdersStatusesReturned"
              clear-icon="mdi-close"
              item-text="title"
              item-value="value"
              label="Trạng thái trả"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
        </v-row>
        <v-row>
          <!-- <v-col cols="12" md="4">
            <DateIOSPicker label="Ngày" outlined dense outline :rules="[$rules.date]" :date.sync="currentDate" />
          </v-col> -->
          <v-col cols="12" md="4">
            <DateIOSPicker label="Từ ngày" outlined dense :date.sync="fromDate" />
          </v-col>
          <v-col cols="12" md="4">
            <DateIOSPicker label="Đến ngày" outlined dense :date.sync="toDate" />
          </v-col>
        </v-row>
      </v-form>
      <v-row class="" v-if="!canFilterByStudent">
        <v-col cols="12">
          <GradeClassStudentSelect @changed="gradeClassStudentChange" />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { get } from 'lodash'
import moment from 'moment'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: {
    DateIOSPicker,
    GradeClassStudentSelect
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: {},
    uniformOrdersStatus: '',
    uniformOrdersStatusReturned: '',
    // currentDate: moment()
    //   .startOf('day')
    //   .toISOString(),
    fromDate: moment().startOf('month').toISOString(),
    toDate: moment().endOf('day').toISOString()
  }),
  computed: {
    ...mapGetters('constant', ['uniformOrderStatuses', 'uniformOrdersStatusesReturned']),

    canFilterByStudent() {
      return get(this.$auth.user, 'role.type') === 'student'
    },
  },
  methods: {
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    onFilterChanged() {
      if (!this.$refs.form.validate()) return
      const params = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        // date: this.currentDate,
        status: this.uniformOrdersStatus,
        statusReturned: this.uniformOrdersStatusReturned,
        grade: get(this.selectedGrade, 'id'),
        class: get(this.selectedClass, 'id'),
        student: get(this.$auth.user, 'role.type') === 'student' ? get(this.$auth.user.student, 'id') : get(this.selectedStudent, 'id')
      }
      this.$emit('onFilterChanged', params)
    }
  },
  created() {
    // const { date } = this.$route.query
    // if (date) {
    //   this.currentDate = date
    // }
  },
  mounted() {
    this.onFilterChanged()
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
